import { Trabajador } from "../../modelo/Trabajador";

export const CONSULTAR_DATOS_TRABAJADOR = "CONSULTAR_DATOS_TRABAJADOR";
export const DATOS_TRABAJADOR_CONSULTADOS = "DATOS_TRABAJADOR_CONSULTADOS";
export const ERROR_CONSULTANDO_DATOS_TRABAJADOR = "ERROR_CONSULTANDO_DATOS_TRABAJADOR";
export const ERROR_AUTORIZACION_CONSULTA_DATOS_TRABAJADOR = "ERROR_AUTORIZACION_CONSULTA_DATOS_TRABAJADOR";

export const consultarDatosTrabajador = (dniEmpleador: string, dniIndependiente: string, id: string) => ({type: CONSULTAR_DATOS_TRABAJADOR, dniEmpleador, dniIndependiente, id});
export const datosTrabajadorConsultados = (trabajador: Trabajador) => ({type: DATOS_TRABAJADOR_CONSULTADOS, trabajador});
export const errorConsultadoDatosTrabajador = () => ({type: ERROR_CONSULTANDO_DATOS_TRABAJADOR});
export const errorAutorizacionConsultaDatosTrabajador = () => ({type: ERROR_AUTORIZACION_CONSULTA_DATOS_TRABAJADOR});


// WEBPACK FOOTER //
// ./src/co/sura/dominio/reportes/modulos/trabajadores/trabajadoresActions.ts